import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  Button,
  TextField,
  Snackbar,
  Alert,
  Backdrop,
  CircularProgress,
  MenuItem,
  Switch, Tooltip,
  Dialog, DialogTitle, DialogContent, DialogActions, Typography
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DeleteDialog from "./components/DeleteDialog";

import CustomTable from "../../components/CustomTable/CustomTable";
import ViewModal from "./ViewModel/ViewModel";
import PaginationControls from "../../components/PaginationControls/PaginationControls";
import AppSnackbar from "../../components/AppSnackbar/AppSnackbar";
import PageLoader from "../../components/PageLoader/PageLoader";
import ServiceFormModal from "./components/ServiceFormModal";
import useServiceAreas from "./services/useServiceHook";

function ServiceArea() {
  const navigate = useNavigate();

  const {
    saveServiceArea,
    serviceAreas,
    searchValue,
    setStatus,
    status,
    setSearchValue,
    currentPage,
    totalPages,
    handleStatusToggle,
    handledeleteServiceArea,
    setCurrentPage,
    updateServiceAreaData,

  } = useServiceAreas();


  const INITIAL_BANK_STATE = {
    city: "",
    coordinates: "",
    // address: "",
  };

  const [openModal, setOpenModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [serviceData, setserviceData] = useState(INITIAL_BANK_STATE);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleSearchChange = (e) => {
    setCurrentPage(1);
    setSearchValue(e.target.value);
  };

  const handleOpenModal = () => {
    setserviceData(INITIAL_BANK_STATE);
    setIsEditing(false);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setserviceData(INITIAL_BANK_STATE);
    setIsEditing(false);
    setCurrentId(null);
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    setserviceData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleServiceSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let parsedCoordinates = [];

    try {
      parsedCoordinates = JSON.parse(serviceData.coordinates);
      parsedCoordinates = [parsedCoordinates];
    } catch (error) {
      alert("Invalid coordinates! Please enter a valid array of [lng, lat] pairs.");
      return;
    }

    const payload = {
      city: serviceData.city,
      polygon: {
        type: "Polygon",
        coordinates: parsedCoordinates,
      },
    };

    console.log("Payload to submit:", payload);
    try {
      let res;
      if (isEditing && currentId) {
        res = await updateServiceAreaData(currentId, payload);
      } else {
        res = await saveServiceArea(payload);
      }

      if (res?.success) {
        showSnackbar(
          isEditing ? "Service area updated successfully" : "Service area created successfully",
          "success"
        );
        setLoading(false);
        setOpenModal(false);
      } else {
        showSnackbar(res?.message || "Save failed", "error");
        setLoading(false);
        setOpenModal(false);
      }
    } catch (error) {
      showSnackbar("Something went wrong", "error");
      setLoading(false);
    }
  };


  const handleEditClick = (id, serviceData) => {
    setCurrentId(id);
    setserviceData({
      city: serviceData.city,
      coordinates: JSON.stringify(serviceData.polygon.coordinates[0] || []),
    });
    setIsEditing(true);
    setOpenModal(true);
  };

  const columns = [
    { key: "city", label: "City" },

    {
      key: "status",
      label: "Status",
      render: (value, row) => (
        <Tooltip title={value === "active" ? "Deactivate" : "Activate"}>
          <Switch
            checked={value === "active"}
            color="success"
            onChange={() => handleStatusTogglee(row)}
          />
        </Tooltip>
      ),
    },

    // {
    //   key: "createdAt",
    //   label: "Created At",
    //   render: (value) => new Date(value).toLocaleDateString(),
    // },
  ];

  const handleViewDetails = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleToggleClick = (item) => {
    setSelectedItem(item); // store the item
    setConfirmOpen(true);   // open confirmation dialog
  };
  const handleStatusTogglee = async (item) => {
    setLoading(true);
    const newStatus = item.status === "active" ? "inactive" : "active";
    const payload = {
      id: item.id,
      status: newStatus
    };
    console.log(payload);
    // Call your API
    await handleStatusToggle(payload.id, payload.status);
    // console.log(res);
    showSnackbar("Status updated successfully", "success")
    setConfirmOpen(false);
    setSelectedItem(null);
    setModalOpen(false);
    setLoading(false);
  };
  const handleCancel = () => {
    setConfirmOpen(false);
    setSelectedItem(null);
  };
  const handleConfirmDelete = async () => {
    if (!currentId) return;

    try {
      await handledeleteServiceArea(currentId);
      showSnackbar("Service area deleted successfully", "success");
    } catch (err) {
      showSnackbar("Something went wrong while deleting", "error");
    } finally {
      setDeleteDialogOpen(false);
      setCurrentId(null);
    }
  };

  // 
  const navigateWeb = () => window.open('https://geojson.io/', '_blank');

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {/* Header */}
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Service Area
                </MDTypography>
              </MDBox>

              {/* Search */}
              <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
                {/* Left side: Search input */}
                <TextField
                  label="Search"
                  placeholder="Search bank name"
                  size="small"
                  sx={{ maxWidth: 360, width: "100%" }}
                  value={searchValue}
                  onChange={handleSearchChange}
                />

                {/* Right side: Status dropdown + Create Bank button */}
                <MDBox display="flex" alignItems="center" ml={2} gap={1}>
                  {/* Status dropdown */}
                  <TextField
                    select
                    size="small"
                    value={status}
                    onChange={(e) => {
                      setStatus(e.target.value);
                      setCurrentPage(1); // reset to first page when filter changes
                    }}
                    sx={{
                      minWidth: 150,
                      "& .MuiSelect-select": {
                        color: "gray",      // text color
                        fontWeight: 500,    // medium weight
                        fontSize: 20,       // adjust size as needed
                      },
                    }}
                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                  </TextField>


                  {/* Create Bank button */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={navigateWeb}
                    style={{
                      whiteSpace: "nowrap",
                      color: "white",
                    }}
                  >
                    JeoJson
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenModal}
                    style={{
                      whiteSpace: "nowrap",
                      color: "white",
                    }}
                  >
                    Create Service
                  </Button>
                </MDBox>
              </MDBox>



              {/* add customer table */}
              <CustomTable
                data={serviceAreas || []}
                columns={columns}
                onViewDetails={handleViewDetails}
                onEditClick={(row) => handleEditClick(row.id, row)}
                onDeleteClick={(row) => {
                  setCurrentId(row.id);
                  setDeleteDialogOpen(true);
                }}
                onStatusToggle={handleStatusTogglee}
              />


              {/* Pagination */}
              <PaginationControls
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />

      {/* Bank Form Modal */}
      <ServiceFormModal
        open={openModal}
        isEditing={isEditing}
        formData={serviceData}
        // onClose={handleCloseModal}
        onChange={handleBankChange}
        onSubmit={handleServiceSubmit}
        onClose={() => setOpenModal(false)}
      />

      <ViewModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        data={selectedItem}
      // onAction={handleModalAction}
      />


      {/* delete */}
      <DeleteDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={handleConfirmDelete}
      />


      {/* LOADER */}
      <PageLoader open={loading} />

      {/* SNACKBAR */}
      <AppSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </DashboardLayout>
  );
}

export default ServiceArea;
